import identity from "lodash/identity";
import pickBy from "lodash/pickBy";

export default function stripUndefined<T extends Record<string, any>>(data: T) {
  return pickBy(data, identity);
}
